<edl-authenticated>
    <banner></banner>
</edl-authenticated>